import {
  ConversationParticipant,
  GetConversationParticipantsParams,
  GetConversationParticipantsResponse,
} from '@stripe-internal/conversations-client';
import {ApiMethods} from './ApiMethods';
import {FrameworkAdapter} from './FrameworkAdapter';

type GetConversationParticipantsHandlerDeps = {
  getConversation: (
    conversationId: string,
  ) => ReturnType<ApiMethods['getConversation']>;
};

export class GetConversationParticipantsHandler {
  private deps: GetConversationParticipantsHandlerDeps;

  constructor(deps: GetConversationParticipantsHandlerDeps) {
    this.deps = deps;
  }

  call = async (
    params?: GetConversationParticipantsParams,
  ): Promise<GetConversationParticipantsResponse> => {
    if (!params?.conversationId) {
      return {code: 400, error: 'Missing conversationId'};
    }

    const response = await this.deps.getConversation(params.conversationId);
    if (response.type === 'error') {
      return FrameworkAdapter.toClientErrorResponse(response);
    }

    const framework = FrameworkAdapter.fromApiConversation({
      apiConversation: response.data,
      requestContext: {},
    });

    const allParticipants = framework.participants;
    const participants: Record<string, ConversationParticipant> =
      params.participantIds
        ? Object.fromEntries(
            params.participantIds
              .filter((id) => id in allParticipants)
              .map((id) => [id, allParticipants[id]]),
          )
        : allParticipants;

    return {code: 200, data: {participants}};
  };
}
